<template>
  <v-app class="app-tabela">
    <!-- <div class="info-table py-4">
      <div class="info-table-item">
        <vue-select
          :options="periodos"
          label="label"
          placeholder="Período"
          v-model="periodo"
          @input="handlePeriod($event)"
          :clearable="true"
        >
          <template slot="option" slot-scope="option">
            {{ option.label }}
          </template>
          <div slot="no-options">Não há opções correspondentes</div>
        </vue-select>
      </div>
    </div> -->
    <v-card class="tabela">
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          class="input-bottom"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        @pagination="getPagination"
        :page="currentPage"
        :footer-props="{
          itemsPerPageText: '',
          'items-per-page-options': [10],
          'disable-items-per-page': true,
        }"
        :loading="loading"
        loading-text="Carregando, Por favor espere"
        :headers="headers"
        :items="indexedItems"
        :search="search"
        item-key="index"
        class="elevation-1"
        :single-expand="true"
        :expanded.sync="expanded"
        show-expand
      >
        <template v-slot:header.situacao="{ header }">
          {{ header.text }}
          <span
            v-b-tooltip.hover.right
            :title="header.tooltip"
            class="icon-tooltip"
          >
            <i class="icofont-info-circle"></i>
          </span>
        </template>

        <template v-slot:item.no_equipe="{ item }">
          <td>
            {{ item.nu_ine }}
            <span
              v-if="item.no_equipe"
              v-b-tooltip.hover
              v-bind:title="item.no_equipe"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </td>
        </template>

        <template v-slot:item.co_cbo="{ item }">
          <td>
            {{ item.nu_cbo }}
            <span
              v-if="item.no_cbo"
              v-b-tooltip.hover
              v-bind:title="item.no_cbo"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </td>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td colspan="9">
            <table class="table table-interna table-interna-acompanhamento">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>CFCP</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ item.id }}</td>
                  <td>{{ item.cfcp }}</td>
                </tr>
              </tbody>
            </table>

            <b-alert
              v-if="item.dt_nascimento != cidadao.dt_nascimento"
              variant="danger"
              show
              class="mt-4"
            >
              A data de nascimento registrada nesse atendimento
              {{
                item.dt_nascimento != null ? formatDate(item.dt_nascimento) : ''
              }}
              é diferente da data de nascimento atual do cidadão
              {{
                cidadao.dt_nascimento != null
                  ? formatDate(cidadao.dt_nascimento)
                  : ''
              }}.
            </b-alert>

            <b-alert
              v-if="item.no_equipe == 'SEM EQUIPE'"
              variant="danger"
              show
              class="mt-4"
            >
              O profissional que realizou atendimento não está vinculado a uma
              equipe.
            </b-alert>

            <b-alert
              v-if="
                filtroAtendimento.filtro == 'gestante' &&
                !tipoContem(item, 'parto')
              "
              variant="danger"
              show
              class="mt-2"
            >
              Não foi registrado CID ou CIAP relacionado a GRAVIDEZ nesse
              atendimento.
            </b-alert>

            <b-alert
              v-if="
                filtroAtendimento.filtro == 'diabetes' &&
                !tipoContem(item, 'diabetes')
              "
              variant="danger"
              show
              class="mt-2"
            >
              Não foi registrado CID ou CIAP relacionado a DIABETES nesse
              atendimento.
            </b-alert>

            <b-alert
              v-if="
                filtroAtendimento.filtro == 'hipertensao' &&
                !tipoContem(item, 'hipertensao')
              "
              variant="danger"
              show
              class="mt-2"
            >
              Não foi registrado CID ou CIAP relacionado a HIPERTENSÃO nesse
              atendimento.
            </b-alert>

            <b-alert
              v-if="
                filtroAtendimento.filtro == 'mulher' &&
                !tipoContem(item, 'saude sexual')
              "
              variant="danger"
              show
              class="mt-2"
            >
              Não foi registrado CID ou CIAP relacionado a ORIENTAÇÃO SEXUAL E
              REPRODUTIVA nesse atendimento.
            </b-alert>

            <b-alert
              v-if="item.cfcp != cidadao.cfcp"
              variant="danger"
              show
              class="mt-2"
            >
              Atendimento registrado com CPF e o cadastro do cidadão está sem
              CPF. Recomenda-se atualizar o cadastro do cidadão com o CPF para
              qualificar os dados.
            </b-alert>
          </td>
        </template>

        <template v-slot:[`footer.page-text`]="items">
          <div class="info-table-item tabela-esus-pec">
            <FonteSincronizadorC />
          </div>
          <span class="paginacao"
            >{{ items.pageStart }} - {{ items.pageStop }} de
            {{ items.itemsLength }} registros</span
          >
        </template>

        <template v-slot:no-data>
          <div class="alert alert-info mb-0">
            <b>Nenhuma informação encontrada.</b>
          </div>
        </template>
        <template v-slot:no-results style="padding: 0px">
          <div class="alert alert-info mb-0">
            <b>Nenhuma informação encontrada.</b>
          </div>
        </template>

        <template v-slot:item.dt_atendimento="{ item }">
          <td>
            {{
              item.dt_atendimento != null ? formatDate(item.dt_atendimento) : ''
            }}
          </td>
        </template>

        <template v-slot:item.tipo="{ item }">
          <td>
            {{ item.tipo != null ? JSON.parse(item.tipo).join(', ') : '' }}
          </td>
        </template>
      </v-data-table>
    </v-card>
  </v-app>
</template>

<script>
import utils from '@/mixins/utils.js'

export default {
  name: 'Atendimentos',
  props: {
    cidadao: {
      type: Object,
      default: () => null,
    },
    filtroAtendimento: {
      type: Object,
      default: () => ({ filtro: null, operador: '>=', data: '' }),
    },
    cnsList: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [utils],
  data() {
    return {
      expanded: [],
      headers: [
        {
          text: 'ATENDIMENTO',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'dt_atendimento',
        },
        {
          text: 'CPF',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'cpf',
        },
        {
          text: 'CNS',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'cns',
        },
        {
          text: 'EQUIPE',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'no_equipe',
        },
        {
          text: 'CBO',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'co_cbo',
        },
        {
          text: 'TIPO',
          align: 'start',
          filterable: true,
          sortable: false,
          value: 'tipo',
        },
        { text: '', value: 'data-table-expand' },
      ],
      cadastrosOriginais: [],
      cadastros: [],
      currentPage: 1,
      search: '',
      loading: false,
      periodos: [{ label: 'Últimos 13 meses', value: 13 }],
      periodo: null,
    }
  },
  mounted() {
    this.buscarDados()
  },
  computed: {
    cadastrosFiltrados() {
      const { operador, data } = this.filtroAtendimento || {}

      // sem data ou sem operador: retorna tudo
      if (!data || !operador) return this.cadastros

      return this.cadastros.filter((item) => {
        const dataItem = item.dt_atendimento.split('/').reverse().join('-')
        return this._compareDates(dataItem, data, operador)
      })
    },

    indexedItems() {
      return this.cadastrosFiltrados.map((item, index) => ({
        index,
        ...item,
      }))
    },
  },
  methods: {
    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Compara duas datas no formato YYYYMMDD.
     * @param {String} aYmd Primeira data
     * @param {String} bYmd Segunda data
     * @param {String} op Operador de comparação
     * @returns {Boolean}
     */
    _compareDates(aYmd, bYmd, op) {
      if (!aYmd || !bYmd) return true
      switch (op) {
        case '>':
          return aYmd > bYmd
        case '<':
          return aYmd < bYmd
        case '>=':
          return aYmd >= bYmd
        case '<=':
          return aYmd <= bYmd
        case '=':
          return aYmd === bYmd
        default:
          return true
      }
    },

    /**
     * Calcula a diferença em meses entre a data informada e hoje.
     * @param {String} date Data no formato YYYY-MM-DD
     * @returns {Number} Quantidade de meses
     */
    diffMonthsFromDate(date) {
      const [year, month, day] = date.split('-')
      const startDate = new Date(year, month - 1, day)
      let today = new Date()
      let months = (today.getFullYear() - startDate.getFullYear()) * 12
      months -= startDate.getMonth()
      months += today.getMonth()
      return months
    },

    /**
     * Filtra os cadastros pelo período informado.
     * @param {Object|null} periodo Período selecionado
     */
    handlePeriod(periodo) {
      if (periodo == null) {
        this.cadastros = this.cadastrosOriginais
        return
      }
      this.cadastros = this.cadastrosOriginais.filter((item) => {
        let itemDate = item.dt_atendimento
        let monthsDiff = this.diffMonthsFromDate(itemDate)
        return monthsDiff <= periodo.value
      })
    },

    /**
     * Busca os dados
     */
    async buscarDados() {
      try {
        this.loading = true

        const response = await this.$api.get(
          `/app/cidadao/${this.$store.state.cod_ibge}/${this.cidadao.nu_cpf}/${this.cidadao.nu_cns}/unificacoes`
        )
        if (response) {
          let cnsListUnificacoes = [
            ...new Set(
              response.data
                .map((i) => (i?.cns != null ? String(i.cns).trim() : null))
                .filter((cns) => cns !== null && cns !== '')
            ),
          ]
          if (cnsListUnificacoes.length == 0) {
            cnsListUnificacoes = [0]
          }

          const response2 = await this.$api.post(`/app/cidadao/atendimentos`, {
            co_ibge: this.$store.state.cod_ibge,
            cpf: this.cidadao.nu_cpf,
            cns: cnsListUnificacoes,
          })
          if (response2) {
            this.cadastrosOriginais = response2.data
            this.cadastros = response2.data
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    /**
     * Verifica se o tipo do item contém o termo informado.
     * @param {Object} item Item da listagem
     * @param {String} termo Texto a ser buscado
     * @returns {Boolean}
     */
    tipoContem(item, termo) {
      if (!item.tipo) return false

      // Normaliza textos (remove acentos e baixa-case)
      const normalizar = (str) =>
        str
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()

      const termoNormalizado = normalizar(termo)

      let tipos = []

      try {
        tipos = JSON.parse(item.tipo)
      } catch (e) {
        return false
      }

      // Normaliza todos os itens e verifica se contém o termo
      return tipos
        .map((t) => normalizar(t))
        .some((t) => t.includes(termoNormalizado))
    },
  },
}
</script>

<style></style>
